import { NgStyle } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [NgStyle],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent implements AfterViewInit, OnDestroy {
  @Input() class: string | null = null;
  @Input() ngStyle: any;
  @Output() overlayClick: EventEmitter<Event> = new EventEmitter();

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit(): void {
    this.renderer.appendChild(
      window.document.body,
      this.elementRef.nativeElement,
    );
  }

  ngOnDestroy(): void {
    this.renderer.removeChild(document.body, this.elementRef.nativeElement);
  }

  handleOverlayClick(event: Event) {
    this.overlayClick.emit(event);
  }
}
